import {
  CLEAR_SANTA_ERROR,
  FETCH_SANTA_AVAILABLE_TIMESLOTS,
  SET_SANTA_TIMESLOT_TIMEZONE,
  STORE_RESERVATION_WAS_SUCCESSFULLY_BOOKED,
  STORE_REVERATION_WAS_UNSUCCESSFUL,
  STORE_SANTA_API_RETURNED_UNEXPECTED,
  STORE_SANTA_AVAILABLE_TIMESLOTS,
  SUBMIT_SANTA_SIGNUP_FORM
} from 'store/ducks/santa/types';
import {
  getDefaultTimeSlots,
  getDefaultTimezone,
  transformSlotsForTimezone
} from 'helpers/meetSanta';

const defaultState = {
  isLoading: false,
  isLoaded: false,
  isEligible: true, // there exists an open time slot in a day >= today
  errorCallingApi: false, // if non 200/400 reponse code from server, used to tell customer to call
  timeSlotsByDay: {},
  timezone: null,
  defaultTimeSlots: null,
  supportedTimeZones: [
    { value: 'HST', label: 'Hawaii Time' },
    { value: 'AST', label: 'Alaska Time' },
    { value: 'PST', label: 'Pacific Time' },
    { value: 'MST', label: 'Mountain Time' },
    { value: 'CST', label: 'Central Time' },
    { value: 'EST', label: 'Eastern Time' }
  ]
  // bookingWasSuccessful: true // submission was successful
};

export default function santaReducer(state = defaultState, action = {}) {
  const {
    type,
    payload,
    timeslotBecameUnavailable,
    timezone
  } = action;

  switch (type) {
    case STORE_SANTA_API_RETURNED_UNEXPECTED: {
      const { isLoaded, timezone, defaultTimeSlots } = state;

      let newState = { ...state, errorCallingApi: true, isLoading: false, isLoaded: true, isEligible: isLoaded };

      if (timezone === null) {
        newState = { ...newState, timezone: getDefaultTimezone() };
      }

      if (defaultTimeSlots === null) {
        newState = { ...newState, defaultTimeSlots: getDefaultTimeSlots() };
      }

      return newState;
    }

    case STORE_RESERVATION_WAS_SUCCESSFULLY_BOOKED: {
      return { ...state, showTimeDoesntWorkForCustomer: false, isLoading: false, errorCallingApi: false };
    }

    case STORE_REVERATION_WAS_UNSUCCESSFUL: {
      return { ...state, showTimeDoesntWorkForCustomer: true, isLoading: false, errorCallingApi: false };
    }

    case SET_SANTA_TIMESLOT_TIMEZONE: {
      return storeSlotLabel({ ...state, timezone });
    }

    case STORE_SANTA_AVAILABLE_TIMESLOTS: {
      const { timezone, defaultTimeSlots } = state;

      let newState = {
        ...state,
        timeSlotsByDay: payload,
        isLoaded: true,
        isLoading: false,
        timeslotBecameUnavailable
      };

      if (timezone === null) {
        newState = { ...newState, timezone: getDefaultTimezone() };
      }

      if (defaultTimeSlots === null) {
        newState = { ...newState, defaultTimeSlots: getDefaultTimeSlots() };
      }

      newState = storeSlotLabel(newState);
      newState = storeStateFlags(newState);

      return newState;
    }

    case FETCH_SANTA_AVAILABLE_TIMESLOTS: {
      return { ...state, isLoading: true };
    }

    case SUBMIT_SANTA_SIGNUP_FORM: {
      return { ...state, isLoading: true };
    }

    case CLEAR_SANTA_ERROR: {
      return { ...state, errorCallingApi: false, showTimeDoesntWorkForCustomer: false };
    }

    default: {
      return state;
    }
  }
}

export function storeStateFlags(state) {
  const { timeSlotsByDay } = state;
  const today = new Date().getDate();
  const eligibleDays = {};

  let isEligible = false;
  let isBooked = false;
  let dayBooked;
  let timeBooked;

  Object.keys(timeSlotsByDay).forEach(day => {
    if (timeSlotsByDay[day].find(slot => slot.isAvailable)) {
      if (day >= today) {
        isEligible = true;
      }
      eligibleDays[day] = true;
    }

    const bookedSlot = timeSlotsByDay[day].find(({ isBooked }) => isBooked) || {};

    if (bookedSlot.value) {
      isBooked = true;
      dayBooked = day;
      timeBooked = { value: bookedSlot.value, label: bookedSlot.label };
    }
  });

  return {
    ...state,
    eligibleDays,
    isBooked,
    isEligible,
    dayBooked,
    timeBooked
  };
}

export function storeSlotLabel(state) {
  const { timeSlotsByDay, timezone } = state;
  const transformedTimeSlotsByDay = {};

  Object.keys(timeSlotsByDay).forEach(key => {
    const slots = timeSlotsByDay[key];
    transformedTimeSlotsByDay[key] = transformSlotsForTimezone({ slots, timezone });
  });

  return { ...state, timeSlotsByDay: transformedTimeSlotsByDay };
}
